import { render, staticRenderFns } from "./advantage.vue?vue&type=template&id=20f46316&scoped=true"
import script from "./advantage.vue?vue&type=script&lang=js"
export * from "./advantage.vue?vue&type=script&lang=js"
import style0 from "./advantage.vue?vue&type=style&index=0&id=20f46316&prod&lang=css"
import style1 from "./advantage.vue?vue&type=style&index=1&id=20f46316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f46316",
  null
  
)

export default component.exports